import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "../pages/remittance-beta/state/authSlice";
import remittanceReducer from "../pages/remittance-beta/state/remittanceSlice";
import historyReducer from "../pages/history/state/historySlice";
import configReducer from "../state/config/configSlice";

const authPersistConfig = {
  key: "auth_state",
  storage,
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  remittance: remittanceReducer,
  history: historyReducer,
  config: configReducer,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
